export const T = {
  en_GB: {
    failedToLoad: "Could not load the accounts.",
  },
  nb_NO: {
    failedToLoad: "Kunne ikke laste kontoene.",
  },
} as const;
